// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1_V4P","overflowing":"ReadFullNote_overflowing__1ior8"};